import React from "react";

function HotProjectChip() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0px 6px",
        margin: "0px 4px",
        color: "white",
        background: "#bdbdbd",
        textDecoration: "underline",
        textDecorationColor: "#bdbdbd",
        fontSize: 12,
        borderRadius: 16,
        height: 15,
      }}
    >
      Archived
    </div>
  );
}

export default HotProjectChip;
